module.exports = __webpack_public_path__ + "static/media/微信扫码打印.c83e7fc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SelfPrinting/微信扫码打印.mp4
// module id = HdyQ
// module chunks = 10